import { z } from 'zod'

export const MEMBERSHIP_BINDING_WRITE_CONTRACT_VERSION = '1.0.0' as const

export const membershipBindingWriteResponseSchema = z.record(z.unknown())

export type MembershipBindingWriteResponse = z.infer<typeof membershipBindingWriteResponseSchema>
